import React, { useState } from 'react';
import { toast } from '../../Common/Toast';

const InterviewSetupModal = ({ show, onClose, onStart, teamName, selectedFriends = [] }) => {
  const [interviewData, setInterviewData] = useState({
    mode: 'video',
    capture: ['wearables', 'camera', 'voice']
  });
  const [isStarting, setIsStarting] = useState(false);

  const interviewModes = [
    { value: 'in_person', label: '👥 In Person' },
    { value: 'video', label: '📹 Video Meeting' },
  ];

  const captureModes = [
    { value: 'wearables', label: '⌚ Wearables' },
    { value: 'voice', label: '🎤 Voice' },
    { value: 'camera', label: '📸 Camera' }
  ];

  const handleModeChange = (e) => {
    setInterviewData(prev => ({
      ...prev,
      mode: e.target.value,
      capture: e.target.value === 'video'
        ? ['wearables', 'camera', 'voice']
        : ['wearables']
    }));
  };

  const handleCaptureChange = (e) => {
    const value = e.target.value;
    const isChecked = e.target.checked;
    setInterviewData(prev => ({
      ...prev,
      capture: isChecked
        ? [...prev.capture, value]
        : prev.capture.filter(item => item !== value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isStarting) return;
    if (selectedFriends.length === 0) {
      toast.error('No candidates selected');
      return;
    }
    setIsStarting(true);
    try {
      // Send candidates array to onStart
      await onStart({
        mode: interviewData.mode,
        capture: interviewData.capture,
        candidates: selectedFriends.map(f => f.user_id)   // array of user IDs
      });
      onClose();
      setInterviewData({ mode: 'video', capture: ['camera', 'voice'] });
    } catch (error) {
      console.error('Error in interview setup:', error);
      toast.error(error.message || 'Failed to start interview');
    } finally {
      setIsStarting(false);
    }
  };

  if (!show) return null;

  const candidateCount = selectedFriends.length;
  const candidateLabel = candidateCount === 1
    ? `${selectedFriends[0].first_name} ${selectedFriends[0].last_name}`
    : `${candidateCount} candidates`;

  return (
    <div className="teams-modal-overlay">
      <div className="teams-modal interview-setup-modal">
        <div className="teams-modal-header">
          <h2>
            Start Interview for{' '}
            <span className="candidate-name">{candidateLabel}</span>
          </h2>
          <button className="teams-modal-close" onClick={onClose} type="button" disabled={isStarting}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="teams-modal-form">
          <div className="form-group">
            <div className="info-banner mb-3 mt-1">
              <span className="me-1">ℹ️</span>
              <span>This interview will include 25 questions (5 from each round). Questions will appear every 2 minutes.</span>
            </div>
            <label>Interview Mode *</label>
            <select value={interviewData.mode} onChange={handleModeChange}
                    className="team-type-select" required disabled={isStarting}>
              {interviewModes.map(mode => (
                <option key={mode.value} value={mode.value}>{mode.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Capture Mode *</label>
            <div className="checkbox-group">
              {captureModes.map(mode => (
                <label key={mode.value} className="checkbox-label">
                  <input
                    type="checkbox"
                    value={mode.value}
                    checked={interviewData.capture.includes(mode.value)}
                    onChange={handleCaptureChange}
                    disabled={isStarting}
                  />
                  <span className="ms-2 checkbox-text">{mode.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="teams-modal-actions">
            <button type="button" className="submit-btn bg-light text-black border" onClick={onClose} disabled={isStarting}>
              Cancel
            </button>
            <button type="submit" className="submit-btn" disabled={isStarting}>
              {isStarting ? 'Starting...' : 'Start Interview'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InterviewSetupModal;